// Legal document URLs, shared by every surface that has to link them: the
// account-creation clickwrap (RQ16043652, see TermsAcknowledgment.tsx) and the
// persistent landing footer.
//
// Meta Terms is the required link. facebook.com/legal/terms is the approved
// interim target — to be swapped for a DreamWright-specific Terms URL later.
// Single source of truth: change the URLs here only.
export const META_TERMS_URL = 'https://www.facebook.com/legal/terms'
export const META_PRIVACY_URL = 'https://www.facebook.com/privacy/policy'

/**
 * Version of the terms presented at account creation, recorded with every
 * acceptance in `public.terms_acceptances` (RFC-1457).
 *
 * BUMP THIS whenever the URLs above change or the terms themselves are
 * materially revised. Without a bump, acceptances of the old and new terms are
 * indistinguishable in the audit log — which is the single thing that log
 * exists to tell you. Mirrors `CONSENT_POLICY_VERSION` in consent/consentTypes.
 */
export const TERMS_POLICY_VERSION = '1'
